import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Icon from '../../core/patterns/icon/icon'

import styles from './notification.css'
import close from '../../resources/svgs/Cross.svg'

export default class Notification extends PureComponent {
  static propTypes = {
    shown: PropTypes.bool,
    timeout: PropTypes.number,
    children: PropTypes.element,
    onClose: PropTypes.func,
    onAnimationEnded: PropTypes.func,
    festivalMap: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.timer = null
    this.state = {
      shown: props.shown,
      timeout: props.timeout || 7000,
    }
  }

  componentWillMount() {
    if (this.props.shown) {
      this.toggle(true)
      this.toggleTimeout()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.shown && nextProps.shown !== this.state.shown) {
      this.toggle(true)
      this.toggleTimeout()
    }
  }

  closeNotification = () => {
    this.toggle(false)
    clearTimeout(this.timer)
    if (this.props.onAnimationEnded) {
      this.props.onAnimationEnded()
    }
  }

  toggleTimeout = () => {
    this.timer = setTimeout(() => {
      this.toggle(false)

      if (!this.props.onAnimationEnded) return false
      this.props.onAnimationEnded()
    }, this.state.timeout)
  }

  toggle = shown => {
    this.setState(state => ({ ...state, shown }))
    if (!shown && this.props.onClose) this.props.onClose()
  }

  render() {
    if (this.state.shown === false) return null

    const isIE = !!window.MSInputMethodContext && !!document.documentMode
    const containerClassName = isIE
      ? this.props.festivalMap
        ? `${styles['container']} ${styles['container--ie--map']}`
        : `${styles['container']} ${styles['container--ie']}`
      : `${styles['container']}`

    return (
      <div
        data-automationid="notification"
        className={`${containerClassName} ${styles['animatein']}`}
      >
        <button onClick={this.closeNotification} className={styles['remove']}>
          <Icon
            width={20}
            height={20}
            className={styles['icon']}
            glyph={close}
          />
        </button>
        {this.props.children}
      </div>
    )
  }
}
